import React from 'react';
import { Icon } from '@iconify/react';

export const portfolioData = {
  hero: {
    name: "Mario Panenko",
    roles: ["Web developer", "Network Engineer", "Next.js Developer · Rapid AI Adopter", "Rapid Adapter"],
    subtitle: "Web developer. Robím weby a aplikácie v Reacte a Next.js. Pomáham si nástrojmi ako Claude Code a Antigravity, takže mám hotovo rýchlejšie.",
    ctaText: "Zobraziť projekty",
  },

  about: {
    title: "O mne",
    image: "/profile.jpg",
    description: "Vyštudoval som Technickú univerzitu v Košiciach, odbor Počítačové siete a telekomunikácie. Robím weby a webové aplikácie a rád do nich zapájam AI nástroje, ktoré mi zrýchlia robotu. Novú technológiu sa naučím rýchlo a hneď ju použijem na reálnom projekte.",
  },

  projects: [
    {
      title: "Open Your Mind — oym.sk",
      description: (
        <>
          Moderná react aplikácia zameraná na osobný rozvoj
          <a
            href="https://github.com/majosnv"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-400 ml-2 inline-flex items-center"
            aria-label="GitHub Repository"
          >
            <Icon icon="mdi:github" className="w-6 h-6" />
          </a>
        </>
      ),
      image: "/project1.png",
      url: "https://oym.netlify.app/",
      tech: [
        { name: 'React', icon: 'logos:react' },
        { name: 'CSS', icon: 'vscode-icons:file-type-css' },
        { name: 'emailJS', icon: 'simple-icons:maildotru', color: '#5A5EB9' }
      ]
    },
    {
      title: "Webová aplikácia zameraná na realizáciu logopedických cvičení",
      description: (
        <>
          Bakalárska práca zameraná na zlepšenie a terapeutických nástrojov
          <a
            href="https://github.com/majosnv"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-400 ml-2 inline-flex items-center"
            aria-label="GitHub Repository"
          >
            <Icon icon="mdi:github" className="w-6 h-6" />
          </a>
        </>
      ),
      image: "/project2_1.png",
      url: "https://www.linkedin.com/in/mariopanenko/details/projects/",
      hasGallery: true,
      galleryId: 'project2',
      tech: [
        { name: 'HTML5', icon: 'vscode-icons:file-type-html' },
        { name: 'CSS3', icon: 'vscode-icons:file-type-css' },
        { name: 'JavaScript', icon: 'logos:javascript' },
        { name: 'Python', icon: 'logos:python' },
        { name: 'Swagger', icon: 'simple-icons:swagger', color: '#85EA2D' },
        { name: 'GCP', icon: 'logos:google-cloud' },
        { name: 'Docker', icon: 'logos:docker-icon' }
      ]
    },
    {
      title: "Aplikácia pre slovne-orientované logopedické terapie",
      description: (
        <>
          Úspešne obhájená diplomová práca zameraná na vývoj interaktívnej Next.js aplikácie pre slovne-orientované logopedické terapie s reálnym nasadením v praxi.
          <a
            href="https://diplomovka-robo.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-400 ml-2 inline-flex items-center"
            aria-label="GitHub Repository"
          >
            <Icon icon="mdi:open-in-new" className="w-5 h-5" />
          </a>
        </>
      ),
      image: "/project3_1.png",
      url: "https://diplomovka-robo.vercel.app/",
      hasGallery: true,
      galleryId: 'project3',
      tech: [
        { name: 'Next.js', icon: 'logos:nextjs-icon' },
        { name: 'Tailwind CSS', icon: 'logos:tailwindcss-icon' },
        { name: 'Supabase', icon: 'logos:supabase-icon' },
        { name: 'Vercel', icon: 'logos:vercel-icon' }
      ]
    },
    {
      title: "byadamsoltes.com - Photo portfolio for friend",
      description: (
        <>
          Photography portfolio pre profesionálneho fotografa s masonry galériou a video streamingom
          <a
            href="https://byadamsoltes.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-400 ml-2 inline-flex items-center"
            aria-label="Live Website"
          >
            <Icon icon="mdi:open-in-new" className="w-5 h-5" />
          </a>
        </>
      ),
      image: "/project4_1.png",
      url: "https://byadamsoltes.com/",
      hasGallery: true,
      galleryId: 'project4',
      tech: [
        { name: 'Next.js', icon: 'logos:nextjs-icon' },
        { name: 'Framer Motion', icon: 'simple-icons:framer', color: '#0055FF' },
        { name: 'Sanity', icon: 'logos:sanity', color: '#F03E2F' },
        { name: 'Mux', icon: 'simple-icons:mux', color: '#FF2D55' },
        { name: 'Vercel', icon: 'logos:vercel-icon' },
      ]
    },
  ],

  experience: [
    {
      company: "IBM Slovensko",
      role: "Salesforce Marketing Cloud Consultant (Contract)",
      period: "Jún 2025 – Dec 2025",
      description: "Šesť mesiacov na projekte Salesforce Marketing Cloud pre enterprise klienta. Staval som customer journeys od nuly v SFMC — flow logika, send konfigurácia, data extensions, automatizácie. Distribuovaný tím, komunikácia výhradne v angličtine, delivery tracking cez Workfront a Confluence.",
      skills: ["Salesforce Marketing Cloud", "SFMC", "Customer Journeys", "Workfront", "Confluence", "English"]
    },
    {
      company: "Freelance",
      role: "Web Developer",
      period: "Dec 2020 – súčasnosť",
      description: "Webové aplikácie pre platených klientov od roku 2020. Prevažne Next.js, niekedy s headless CMS (Sanity) keď klient potrebuje publikovať obsah samostatne. Záleží mi na výkone — klient by sa nemal ospravedlňovať za pomalú stránku.",
      skills: ["Next.js", "React", "TypeScript", "Sanity", "Mux", "Vercel", "PostgreSQL", "Supabase"]
    }
  ],

  education: [
    {
      school: "Technická univerzita v Košiciach",
      degree: "Inžinierske štúdium (Ing.), Počítačové sieťové a mobilné technológie",
      period: "Sep 2024 – Máj 2026",
      activities: "Diplomová práca: Aplikácia pre slovne-orientované logopedické terapie (úspešne obhájená)",
      skills: ["Computer Networking", "CCNP", "Next.js", "Artificial Intelligence (AI)", "Scrum", "Network Security", "Python", "DevOps", "Linux"],
      featured: true,
      grade: "Diplomovka: A (92%) | Štátnice (Siete): B (84%)"
    },
    {
      school: "Technická univerzita v Košiciach",
      degree: "Bakalárske štúdium (Bc.), Počítačové siete a telekomunikácie",
      period: "Sep 2021 – Jún 2024",
      activities: "Bakalárska práca: Webová aplikácia zameraná na realizáciu logopedických cvičení (úspešne obhájená)",
      skills: ["JavaScript", "React.js", "Python", "Git", "Java", "Cisco Networking", "Cisco Routers", "C", "MySQL", "PostgreSQL", "Linux"],
      grade: "Bakalárka: B (85%)"
    },
    {
      school: "Technická akadémia Spišská Nová Ves",
      degree: "2675 M ELEKTROTECHNIKA - orientácia: inteligentné technológie",
      period: "Sep 2017 – Jún 2021",
      activities: "Osvedčenie o odbornej spôsobilosti v elektrotechnike podľa § 21",
      skills: ["§ 21 Elektrotechnik", "Elektrotechnika", "PHP", "MySQL", "CCNA", "Python", "Windows Systemy"]
    }
  ],

  skills: [
    {
      title: "Siete a OS (Networking)",
      skills: [
        { name: 'Cisco Routing', icon: 'simple-icons:cisco', color: '#1BA0D7' },
        { name: 'CCNA / CCNP', icon: 'mdi:lan-connect', color: '#2563eb' },
        { name: 'Network Security', icon: 'mdi:security-network', color: '#ef4444' },
        { name: 'Windows Server', icon: 'logos:microsoft-windows' },
        { name: 'Linux', icon: 'logos:linux-tux' },
        { name: 'Virtualizácia (VirtualBox)', icon: 'simple-icons:virtualbox', color: '#188FFF' },
      ]
    },
    {
      title: "Vývoj softvéru (Software Dev)",
      skills: [
        { name: 'React a Next.js', icon: 'logos:react' },
        { name: 'JavaScript', icon: 'logos:javascript' },
        { name: 'Python', icon: 'logos:python' },
        { name: 'Programovanie v C', icon: 'logos:c' },
        { name: 'Git / GitHub', icon: 'logos:git-icon' },
        { name: 'PHP', icon: 'logos:php' },
      ]
    },
    {
      title: "DevOps, Databázy a Iné",
      skills: [
        { name: 'Docker', icon: 'logos:docker-icon' },
        { name: 'MySQL / PostgreSQL', icon: 'logos:mysql' },
        { name: 'FastAPI', icon: 'simple-icons:fastapi', color: '#05998b' },
        { name: 'Scrum', icon: 'mdi:account-group', color: '#f59e0b' },
        { name: 'AI implementácia', icon: 'simple-icons:anthropic', color: '#D97757' },
        { name: 'AI trendy a vzdelávanie', icon: 'mdi:school-outline', color: '#4ade80' },
      ]
    }
  ],

  social: {
    github: "https://github.com/majosnv",
    linkedin: "https://www.linkedin.com/in/mariopanenko/",
    email: "mariopanenko@gmail.com",
    cv: "/MARIOPANENKO-CV-2026.pdf"
  },

  driving: {
    title: "Vodičské oprávnenie",
    period: "Od 24.05.2019 (17 rokov) – súčasnosť",
    age: 24,
    birthDate: "13.02.2002",
    startDate: "24.05.2019",
    licenses: [
      { code: "A", icon: "mdi:motorbike" },
      { code: "A2", icon: "mdi:motorbike" },
      { code: "A1", icon: "mdi:motorbike" },
      { code: "B", icon: "mdi:car" },
      { code: "B1", icon: "mdi:car" }
    ]
  }
};
